document.addEventListener('DOMContentLoaded', function () {
  
  // --- CONFIG: set this to your colour option name ---
  const COLOR_OPTION_NAME = 'Color'; // try 'Colour' if Color doesn't work

  function getSelectedColor() {
    // Works with swatches, dropdowns, and radio buttons
    const swatch = document.querySelector(
      '.product-form__input [data-option-name="' + COLOR_OPTION_NAME + '"] input:checked'
    );
    if (swatch) return swatch.value;

    const select = document.querySelector(
      'select[data-option-name="' + COLOR_OPTION_NAME + '"]'
    );
    if (select) return select.value;

    return null;
  }

  function filterMediaByColor(selectedColor) {
    if (!selectedColor) return;

    const colorLower = selectedColor.toLowerCase();
    const allMedia = document.querySelectorAll(
      '.product__media-list .product__media-item, ' +
      '.product-media-container .product__media-item, ' +
      '[data-product-media-list] li'
    );

    if (!allMedia.length) return;

    let firstVisible = null;

    allMedia.forEach(function (item) {
      const img = item.querySelector('img');
      if (!img) return;

      const altText = (img.alt || '').toLowerCase();
      const srcText = (img.src || '').toLowerCase();

      const isMatch =
        altText.includes(colorLower) ||
        srcText.includes(colorLower);

      if (isMatch) {
        item.style.display = '';
        if (!firstVisible) firstVisible = item;
      } else {
        item.style.display = 'none';
      }
    });

    // Scroll/click first matching thumbnail
    if (firstVisible) {
      const thumb = firstVisible.querySelector('button, a');
      if (thumb) thumb.click();
    }
  }

  function bindVariantChange() {
    // Horizon theme fires this custom event on variant change
    document.addEventListener('variant:change', function (e) {
      const color = e.detail?.variant?.options?.find((_, i) => {
        const optionName = window.__productOptionNames?.[i];
        return optionName?.toLowerCase() === COLOR_OPTION_NAME.toLowerCase();
      });
      if (color) filterMediaByColor(color);
    });

    // Also handle direct clicks on swatches/selects as fallback
    document.querySelectorAll(
      '.product-form__input input[type="radio"], ' +
      'select[data-option-name="' + COLOR_OPTION_NAME + '"]'
    ).forEach(function (el) {
      el.addEventListener('change', function () {
        filterMediaByColor(this.value);
      });
    });
  }

  bindVariantChange();

  // Run on load with current selection
  const initial = getSelectedColor();
  if (initial) filterMediaByColor(initial);
});